import type { ContractRecordMap } from '@libs/data-access/entities'
import momentJs from 'moment'
import * as MomentRange from 'moment-range'

const moment = MomentRange.extendMoment(momentJs as any)

type Props = {
  formContractStart: moment.Moment
  formContractEnd: moment.Moment
  contractId: number | undefined
  contracts: ContractRecordMap
}

export const overlappingOtherContractValidation = ({
  formContractStart,
  formContractEnd,
  contractId,
  contracts
}: Props): { message: string | null; options?: any } => {
  if (!formContractStart || !formContractEnd) {
    return { message: null }
  }

  const currentContractRange = moment.range(formContractStart, formContractEnd)

  const overlappingOtherContract = (
    contractId
      ? contracts.filter(contract => contract?.id !== contractId)
      : contracts
  ).find(contract => {
    if (!contract || !contract?.contract_start) {
      return false
    }

    const contractRange = moment.range(
      moment(contract.contract_start),
      contract.contract_end
        ? moment(contract.contract_end).clone().add(1, 'day').startOf('day')
        : moment()
    )
    return currentContractRange.overlaps(contractRange)
  })

  if (overlappingOtherContract) {
    const {
      contract_start: overlappingContractStart,
      contract_end: overlappingContractEnd,
      contract_type: type
    } = overlappingOtherContract

    return {
      message: overlappingContractEnd
        ? 'contract.info.form.validation.overlappingPeriod'
        : 'contract.info.form.validation.overlapping',
      options: {
        type: `common.app:models.contractType.${type.toLowerCase()}`,
        start: overlappingContractStart,
        end: overlappingContractEnd
      }
    }
  }

  return { message: null }
}
